export default __webpack_public_path__ + "ce8af810cfc8bb5c050c9455b88698b0.png";